import {ExpandedPart, ExpandedPartsProvider} from './ExpandedPartsProvider';
import {BlocksRepository} from '../blocks/BlocksRepository';
import {map, Observable} from 'rxjs';
import {lazy} from '../../../support/lazy';
import {Expander} from './Expander';

export class DefaultExpandedPartsProvider implements ExpandedPartsProvider {
    @lazy()
    public get expandedParts(): Observable<ExpandedPart[]> {
        return this.blocksRepository.blocks.pipe(map((blocks) => this.expander.expand(blocks)));
    }

    constructor(private blocksRepository: BlocksRepository, private expander: Expander = new Expander()) {}
}
